import React from "react"
import PopularArticlesSidebar from '../components/popular-articles-sidebar'
import Post from '../components/blog-post'
import BlockHowToGuidesDemolition from "../components/how-to-guides-demolition"
import ServicesDemolition from "../components/services-demolition"
import LayoutDemolition from "../components/layout-demolition"
import SidebarForm from "../components/sidebarForm"

const BLOGXXXPAGEDEMOLITION = ({ data, pageContext }) => 
{ 
    const title = pageContext.post.title !== undefined ? pageContext.post.title : '';  
    const post = pageContext.post; 
    const env = pageContext.env;
    const code = pageContext.code;
    const populars = pageContext.populars;

    
    const seo = 
    {
        url: post.url,
        env: env,
        code: code,
        page: 'blog',
        blog: post
    }

    return (
        <LayoutDemolition seo={seo} env={env} code={code}  bgcolor={'#f5f5f5'} hidden={true} callToAction={true}>

            <div className="blog">

                <div className="container mb-5">
                    <div className="row">
                        <div className="col-lg-8">
                            <h1 className="main-title">{title}</h1>
                            <div className="posts">
                                <Post post={post} />
                            </div>
                            
                        </div>
                        <div className="col-lg-4">
                            <div className="sidebar">
                                <div className="block">
                                    <div className="card mb-5">                                   
                                        <SidebarForm site={env.site} code="demolition" section="blogs"/>
                                    </div>
                                </div>

                                <div className="block">
                                    <ServicesDemolition  env={env}  />
                                </div>                                

                                <div className="block">
                                    <BlockHowToGuidesDemolition  />
                                </div>

                                <div className="block">
                                    <PopularArticlesSidebar populars={populars} />
                                </div>                                

                            </div>                            
                        </div>
                    </div>
                </div> 
            
            
            </div> 

        </LayoutDemolition>
    )
};

export default BLOGXXXPAGEDEMOLITION;